const ratings = [
  {
    value: 5,
    publication: 'Reviews',
  },
  {
    value: 5,
    publication: 'Report Guru',
  },
  {
    value: 5,
    publication: 'BestTech',
  },
];

export default ratings;
